export default function LoadingScreen() {
  return (
    <div className="fixed inset-0 bg-background flex flex-col items-center justify-center z-[9999]">
      <div className="text-center">
        <div className="w-15 h-15 border-4 border-muted border-t-primary rounded-full animate-spin mb-6 mx-auto" />
        <div className="text-lg text-foreground font-medium">
          جارٍ التحميل...
        </div>
      </div>
    </div>
  )
}
